(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-provider/assets/draw-context.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-provider/assets/draw-context.js');
"use strict";

const _React = React,
  createContext = _React.createContext;
const DrawContext = createContext();
setGlobal('svs.components.tipsen.drawProvider.DrawContext', DrawContext);

 })(window);